import { render, staticRenderFns } from "./address-component.vue?vue&type=template&id=f2ad3d30"
import script from "./address-component.vue?vue&type=script&lang=js"
export * from "./address-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports